import { useState } from 'react';

export const useHoverState = (): [
	boolean,
	{
		onMouseOver: () => void;
		onFocus: () => void;
		onMouseOut: () => void;
		onBlur: () => void;
	},
] => {
	const [isHoveredMouse, setIsHoveredMouse] = useState(false);
	const [isHoveredKeyboard, setIsHoveredKeyboard] = useState(false);

	const onMouseOver = () => {
		setIsHoveredMouse(true);
	};

	const onMouseOut = () => {
		setIsHoveredMouse(false);
	};

	const onFocus = () => {
		setIsHoveredKeyboard(true);
	};

	const onBlur = () => {
		setIsHoveredKeyboard(false);
	};

	return [
		isHoveredMouse || isHoveredKeyboard,
		{
			onMouseOver,
			onMouseOut,
			onFocus,
			onBlur,
		},
	];
};
